import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import "@cloudscape-design/global-styles/index.css";
import { Amplify } from "aws-amplify";

import { store } from "./app/store";
import App from "./App";
import Merchants from "./pages/Merchants";
import Error from "./pages/Error";
import Home from "./pages/Home";
import DependenceCharacter from "./pages/DependenceCharacter";
import NgName from "./pages/NgName";
import Profile from "./pages/Profile";
import Users from "./pages/Users";
import config from "./aws-exports";
import Notice from "./pages/Notice";
import NoticeUpdate from "./pages/NoticeUpdate";
import SignIn from "./pages/SignIn";
import MerchantTypeRegister from "./pages/MerchantTypeRegister";
import MerchantTypeUpdate from "./pages/MerchantTypeUpdate";
import Holdings from "./pages/Holdings";
import MerchantTypes from "./pages/MerchantTypes";
import MerchantInfoInquiry from "./pages/MerchantInfoInquiry";
import HoldingsRegister from "./pages/HoldingsRegister";
import HoldingsUpdate from "./pages/HoldingsUpdate";
import User from "./pages/User";
// import HoldingsProjectContractInsert from "./pages/HoldingsProjectContractInsert";
import Gws from "./pages/Gws";
import GwBusinessInfoRegister from "./pages/GwBusinessInfoRegister";
import GwContractsRegister from "./pages/GwContractsRegister";
import GwContractsUpdate from "./pages/GwContractsUpdate";
import GwBusinessInfoUpdate from "./pages/GwBusinessInfoUpdate";
import TouristIndustries from "./pages/TouristIndustries";
import MerchantInclusionApplication from "./pages/MerchantInclusionApplication";
import MerchantAlternativeDirectApplication from "./pages/MerchantAlternativeDirectApplication";
import IndustryConversion from "./pages/IndustryConversion";
import IndustryConversionRegister from "./pages/IndustryConversionRegister";
import IndustryConversionUpdate from "./pages/IndustryConversionUpdate";
import ApplicationFormList from "./pages/ApplicationFormList";
import StoreDirectApplication from "./pages/StoreDirectApplication";
import SettlementStateChangeApplication from "./pages/SettlementStateChangeApplication";
import ApplicationStatus from "./pages/ApplicationStatus";
import ApplicationInquiry from "./pages/ApplicationInquiry";
import RateAdjustmentCaseList from "./pages/RateAdjustmentCaseList";
import RateAdjustmentCaseRegister from "./pages/RateAdjustmentCaseRegister";
import RateAdjustmentCaseUpdate from "./pages/RateAdjustmentCaseUpdate";
import RateAdjustmentCaseContentsRegister from "./pages/RateAdjustmentCaseContentsRegister";
import RateAdjustmentCaseContentsUpdate from "./pages/RateAdjustmentCaseContentsUpdate";
import RateAdjustmentCaseMerchantRegister from "./pages/RateAdjustmentCaseMerchantRegister";
import RateAdjustmentCaseMerchantUpdate from "./pages/RateAdjustmentCaseMerchantUpdate";
import PriorPayout from "./pages/PriorPayout";
import IndividualCounselingProject from "./pages/IndividualCounselingProject";
import IndividualCounselingProjectRegister from "./pages/IndividualCounselingProjectRegister";
import IndividualCounselingProjectContentsRegister from "./pages/IndividualCounselingProjectContentsRegister";
import IndividualCounselingProjectUpdate from "./pages/IndividualCounselingProjectUpdate";
import IndividualCounselingProjectContentsUpdate from "./pages/IndividualCounselingProjectContentsUpdate";
import IndividualHandlingConfirmation from "./pages/IndividualHandlingConfirmation";
// import MerchantApplicationDirectCorporateInfo from "./pages/MerchantApplicationDirectCorporateInfo";
import CreditCardExamination from "./pages/CreditCardExamination";
import ApplicationInformationUpdate from "./pages/ApplicationInformationUpdate";
import ExaminationsStatus from "./pages/ExaminationsStatus";
import ExaminationInquiry from "./pages/ExaminationInquiry";
// import Notifications from "./pages/NotificationsDummy";
import ExaminationResultHandling from "./pages/ExaminationResultHandling";
import ReexaminationOrders from "./pages/ReexaminationOrders";
import RateUpdate from "./pages/RateUpdate";
// import DirectMerchantUpdate from "./pages/DirectMerchantUpdate";
// import DirectMerchantUpdateConsultation from "./pages/DirectMerchantUpdateConsultation";
import IndividualHandlingConfirmationResultUpdate from "./pages/IndividualHandlingConfirmationResultUpdate";
import MerchantDirectApplicationsPage from "./pages/DirectMerchantApplications";
import MerchantDirectApplicationPage from "./pages/DirectMerchantApplication";
import ApplicationIncompletionReasonRegister from "./pages/ApplicationIncompletionReasonRegister";
import ConversionTool from "./pages/ConversionTool";
import BankAccountInquiry from "./pages/BankAccountsInquiry";
import BankAccounts from "./pages/BankAccounts";
import SwitchPaymentProvider from "./pages/SwitchPaymentProvider";
import AnsweredApplicationRegistration from "./pages/AnsweredApplicationRegistration";

Amplify.configure(config);

const router = createBrowserRouter([
  {
    path: "/sign-in",
    element: <SignIn />,
  },
  {
    path: "/",
    element: (
      <App title="d払いへようこそ">
        <Home />
      </App>
    ),
    errorElement: <Error />,
  },
  {
    path: "/merchants",
    element: (
      <App title="加盟店一覧">
        <Merchants />
      </App>
    ),
  },
  {
    path: "/merchant/inclusion-application",
    element: (
      <App title="加盟店情報申請（包括）">
        <MerchantInclusionApplication />
      </App>
    ),
  },
  {
    path: "/merchant/alternative-direct-application",
    element: (
      <App title="加盟店情報申請（直接・ファイルアップロード）">
        <MerchantAlternativeDirectApplication />
      </App>
    ),
  },
  {
    path: "/dependence-character",
    element: (
      <App title="環境依存文字マッピング定義照会・更新">
        <DependenceCharacter />
      </App>
    ),
  },
  {
    path: "/ngname",
    element: (
      <App title="NG名称定義照会・更新">
        <NgName />
      </App>
    ),
  },
  {
    path: "/users",
    element: (
      <App title="ユーザ一覧">
        <Users />
      </App>
    ),
  },
  {
    path: "/users/:cognitoId",
    element: (
      <App title="ユーザ登録更新">
        <User />
      </App>
    ),
  },
  {
    path: "/notifications",
    element: (
      <App title="通知マスタ一覧">
        <Notice />
      </App>
    ),
  },
  {
    path: "/application-status/credit-card-examination-file",
    element: (
      <App title="審査申請回答登録">
        <CreditCardExamination />
      </App>
    ),
  },
  {
    path: "/profile",
    element: (
      <App title="プロファイル">
        <Profile />
      </App>
    ),
  },
  {
    path: "/notifications/:id",
    element: (
      <App title="通知マスタ更新">
        <NoticeUpdate />
      </App>
    ),
  },
  {
    path: "/merchant-types/regist",
    element: (
      <App title="加盟店種別登録・更新">
        <MerchantTypeRegister />
      </App>
    ),
  },
  {
    path: "/merchant-types/:no",
    element: (
      <App title="加盟店種別登録・更新">
        <MerchantTypeUpdate />
      </App>
    ),
  },
  {
    path: "/holdings",
    element: (
      <App title="ホールディングス案件一覧">
        <Holdings />
      </App>
    ),
  },
  {
    path: "/merchant-types",
    element: (
      <App title="加盟店種別一覧">
        <MerchantTypes />
      </App>
    ),
  },
  {
    path: "/holdings-register",
    element: (
      <App title="ホールディングス案件登録">
        <HoldingsRegister />
      </App>
    ),
  },
  {
    path: "/holdings-update/:companyCode/:name",
    element: (
      <App title="ホールディングス案件照会・更新">
        <HoldingsUpdate />
      </App>
    ),
  },
  //  画面を非表示
  // {
  //   path: "/holdings-contract-insert/:companyCode/:name",
  //   element: (
  //     <App title="ホールディングス案件契約追加">
  //       <HoldingsProjectContractInsert />
  //     </App>
  //   ),
  // },
  {
    path: "/gateway-companies",
    element: (
      <App title="GW一覧">
        <Gws />
      </App>
    ),
  },
  {
    path: "/gateway-companies/regist",
    element: (
      <App title="GW事業者登録">
        <GwBusinessInfoRegister />
      </App>
    ),
  },
  {
    path: "/gateway-companies/:code",
    element: (
      <App title="GW事業者更新">
        <GwBusinessInfoUpdate />
      </App>
    ),
  },
  {
    path: "/gateway-companies-contracts/:gwCompanyCode",
    element: (
      <App title="GW契約内容登録">
        <GwContractsRegister />
      </App>
    ),
  },
  {
    path: "/gateway-companies-contracts/:gwCompanyCode/:gatewayNo",
    element: (
      <App title="GW契約内容更新">
        <GwContractsUpdate />
      </App>
    ),
  },
  {
    path: "/tourist-industry",
    element: (
      <App title="旅行業登録者定義照会・更新">
        <TouristIndustries />
      </App>
    ),
  },
  {
    path: "/industry-conversions",
    element: (
      <App title="業態変換一覧">
        <IndustryConversion />
      </App>
    ),
  },
  {
    path: "/industry-conversion/registry",
    element: (
      <App title="業態変換登録">
        <IndustryConversionRegister />
      </App>
    ),
  },
  {
    path: "/industry-conversion/registry/:no",
    element: (
      <App title="業態変換更新">
        <IndustryConversionUpdate />
      </App>
    ),
  },
  {
    path: "/application-form-list",
    element: (
      <App title="申請様式一覧">
        <ApplicationFormList />
      </App>
    ),
  },
  {
    path: "/store-direct-applications",
    element: (
      <App title="店舗情報申請（直接）">
        <StoreDirectApplication />
      </App>
    ),
  },
  {
    path: "/settlement-state-change-application",
    element: (
      <App title="決済状態変更申請">
        <SettlementStateChangeApplication />
      </App>
    ),
  },
  {
    path: "/applications/direct",
    element: (
      <App title="加盟店申請（直接）一覧">
        <MerchantDirectApplicationsPage />
      </App>
    ),
  },
  {
    path: "/applications/direct/:receiptNumber",
    element: (
      <App title="加盟店申請（直接）">
        <MerchantDirectApplicationPage />
      </App>
    ),
  },
  // // todo step1なし
  // {
  //   path: "/applications/direct",
  //   element: (
  //     <App title="加盟店申請（直接）一覧">
  //       <MerchantDirectApplicationsPage />
  //     </App>
  //   ),
  // },
  // {
  //   path: "/applications/direct/:receiptNumber",
  //   element: (
  //     <App title="加盟店申請（直接）">
  //       <MerchantDirectApplicationPage />
  //     </App>
  //   ),
  // },
  {
    path: "/application-status",
    element: (
      <App title="申請状況照会">
        <ApplicationStatus />
      </App>
    ),
  },
  {
    path: "/application-status/:no",
    element: (
      <App title="申請内容照会">
        <ApplicationInquiry />
      </App>
    ),
  },
  {
    path: "/application-status/:no/update",
    element: (
      <App title="申請情報更新">
        <ApplicationInformationUpdate />
      </App>
    ),
  },
  {
    path: "/rate-adjustment-case-list",
    element: (
      <App title="料率調整案件一覧">
        <RateAdjustmentCaseList />
      </App>
    ),
  },
  {
    path: "/rate-adjustment-case/register",
    element: (
      <App title="料率調整案件情報登録">
        <RateAdjustmentCaseRegister />
      </App>
    ),
  },
  {
    path: "/rate-adjustment-case/:rateAdjustmentCaseNo",
    element: (
      <App title="料率調整案件情報更新">
        <RateAdjustmentCaseUpdate />
      </App>
    ),
  },
  {
    path: "/rate-adjustment-case/contents/:rateAdjustmentCaseNo/:merchantBranchNo",
    element: (
      <App title="調整内容登録">
        <RateAdjustmentCaseContentsRegister />
      </App>
    ),
  },
  {
    path: "/rate-adjustment-case/contents/:rateAdjustmentCaseNo/:merchantBranchNo/:adjustmentBranchNo",
    element: (
      <App title="料率調整案件料率内容更新">
        <RateAdjustmentCaseContentsUpdate />
      </App>
    ),
  },
  {
    path: "/rate-adjustment-case/merchant/register/:rateAdjustmentCaseNo",
    element: (
      <App title="料率調整案件加盟店登録">
        <RateAdjustmentCaseMerchantRegister />
      </App>
    ),
  },
  {
    path: "/rate-adjustment-case/merchant/:rateAdjustmentCaseNo/:merchantBranchNo",
    element: (
      <App title="料率調整案件加盟店更新">
        <RateAdjustmentCaseMerchantUpdate />
      </App>
    ),
  },
  {
    path: "/individual-counseling-project",
    element: (
      <App title="個別相談案件一覧">
        <IndividualCounselingProject />
      </App>
    ),
  },
  {
    path: "/individual-counseling-project/regist",
    element: (
      <App title="個別相談案件登録">
        <IndividualCounselingProjectRegister />
      </App>
    ),
  },
  {
    path: "/individual-counseling-project/:individualConsultationNo",
    element: (
      <App title="個別相談案件更新">
        <IndividualCounselingProjectUpdate />
      </App>
    ),
  },
  {
    path: "/individual-counseling-project-content/register/:individualConsultationNo",
    element: (
      <App title="相談内容登録">
        <IndividualCounselingProjectContentsRegister />
      </App>
    ),
  },
  {
    path: "/individual-counseling-project-content/:individualConsultationNo/:individualConsultationBranchNo",
    element: (
      <App title="相談内容更新">
        <IndividualCounselingProjectContentsUpdate />
      </App>
    ),
  },
  {
    path: "/individual-handling-confirmation",
    element: (
      <App title="個別取扱確認結果一覧">
        <IndividualHandlingConfirmation />
      </App>
    ),
  },
  {
    path: "/prior-payout/shop-ids",
    element: (
      <App title="ID払い出し結果受領・取込(ShopID)">
        <PriorPayout />
      </App>
    ),
  },
  {
    path: "/prior-payout/credit-card-merchant-numbers",
    element: (
      <App title="ID払い出し結果受領・取込(クレカ加盟店番号)">
        <PriorPayout />
      </App>
    ),
  },
  // step1　不要
  // {
  //   path: "/merchant/direct-application/corporate-info/:code",
  //   element: (
  //     <App title="事業者情報確認・更新">
  //       <MerchantApplicationDirectCorporateInfo />
  //     </App>
  //   ),
  // },
  {
    path: "/examination-status",
    element: (
      <App title="審査状況・POS登録状況照会">
        <ExaminationsStatus />
      </App>
    ),
  },
  {
    path: "/examination-inquiry/:examinationApplicationNo",
    element: (
      <App title="審査内容照会">
        <ExaminationInquiry />
      </App>
    ),
  },
  //todo step1　不要
  // {
  //   path: "/alerts",
  //   element: (
  //     <App title="お知らせ一覧">
  //       <Notifications />
  //     </App>
  //   ),
  // },
  {
    path: "/merchant/info-inquiry/:code",
    element: (
      <App title="加盟店情報照会">
        <MerchantInfoInquiry />
      </App>
    ),
  },
  {
    path: "/merchant/rate-update/:code",
    element: (
      <App title="加盟店情報申請">
        <RateUpdate />
      </App>
    ),
  },
  {
    path: "/examination-result-handling/:examinationApplicationNo",
    element: (
      <App title="審査結果取扱登録">
        <ExaminationResultHandling />
      </App>
    ),
  },
  {
    path: "/reexamination-orders/:examinationApplicationNo",
    element: (
      <App title="再審査指示・判定">
        <ReexaminationOrders />
      </App>
    ),
  },
  // カテゴリ：加盟店申請手続き
  // todo step 1 無し
  // {
  //   path: "/direct-merchant-update",
  //   element: (
  //     <App title="加盟店変更内容選択">
  //       <DirectMerchantUpdate />
  //     </App>
  //   ),
  // },
  // {
  //   path: "/direct-merchant-update-consultation",
  //   element: (
  //     <App title="加盟店変更内容選択">
  //       <DirectMerchantUpdateConsultation />
  //     </App>
  //   ),
  // },
  {
    path: "/individual-handling-confirmation-result/:applicationNo",
    element: (
      <App title="個別取扱確認更新">
        <IndividualHandlingConfirmationResultUpdate />
      </App>
    ),
  },
  {
    path: "/application-status/:applicationNo/incompletion-reason-register",
    element: (
      <App title="申請不備理由登録">
        <ApplicationIncompletionReasonRegister />
      </App>
    ),
  },
  {
    path: "/conversion-tool",
    element: (
      <App title="申請代替-変換ツール">
        <ConversionTool />
      </App>
    ),
  },
  {
    path: "/bank-accounts",
    element: (
      <App title="入金口座一覧">
        <BankAccounts />
      </App>
    ),
  },
  {
    path: "/bank-accounts/:companyContractBankAccountNo",
    element: (
      <App title="入金口座情報照会">
        <BankAccountInquiry />
      </App>
    ),
  },
  {
    path: "/bank-accounts/:companyContractBankAccountNo/update",
    element: (
      <App title="入金口座情報更新">
        <BankAccountInquiry />
      </App>
    ),
  },
  {
    path: "/switch-payment-provider",
    element: (
      <App title="Omni PG 切替">
        <SwitchPaymentProvider />
      </App>
    ),
  },
  {
    path: "/answered-application",
    element: (
      <App title="加盟店回答状況登録">
        <AnsweredApplicationRegistration />
      </App>
    ),
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);
